/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useGetAllAttachments
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * useGetAllAttachments
 * @returns {UseQueryResult} useGetAllAttachments
 */
const useGetAllAttachments = ({
	id,
	entityType,
}: {
	id: string;
	entityType: EntityTypeEnum;
}): UseQueryResult<EntityAttachmentResponse[], IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.allAttachments, { id, entityType }],
		queryFn: async () => {
			const { data } = await api.AttachmentApi.getEntityAttachments({ entityId: id, entityType });
			return data;
		},
	});
};

export default useGetAllAttachments;
